import { useQuery } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import React from "react";
import { fetchSampleInformation } from "services/sampleCollection";
import { STALE_TIME } from "utils/constants";

const SampleInformation = ({ onClose, rowData }) => {
  const { showAlert } = useAlert();
  const { data: data1 } = useQuery(
    ["fetch-investigation-observation"],
    () => fetchSampleInformation(rowData.appointment_id),
    {
      staleTime: STALE_TIME,
      onSuccess: (res) => {},
      onError: (err) => {
        console.error("Error fetching observations:", err);
        showAlert("Failed to fetch observations!", "danger");
      },
    }
  );

  const patient = data1?.data[0];

  return (
    <>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-6">
            <div className="info-item">
              <span className="info-label">Lab No:</span>
              <span className="info-value">{rowData?.labNo || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Patient Name:</span>
              <span className="info-value">
                {patient?.patient_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Phone/Mobile:</span>
              <span className="info-value">{patient?.mobile || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Refer Doctor:</span>
              <span className="info-value">
                {patient?.refer_doctor_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Register Date:</span>
              <span className="info-value">
                {rowData?.registerDate || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Collected Date:</span>
              <span className="info-value">
                {rowData?.collectedDate || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Lab Received Date:</span>
              <span className="info-value">
                {rowData?.labReceivedDate || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Rejected Date:</span>
              <span className="info-value">
                {rowData?.rejectedDate || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Phlebot Name:</span>
              <span className="info-value">
                {rowData?.phlebotName || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Result Entered Date:</span>
              <span className="info-value">
                {rowData?.resultEnteredDate || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved By:</span>
              <span className="info-value">{rowData?.approvedBy || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved Login By:</span>
              <span className="info-value">
                {rowData?.approvedLoginBy || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Report Print By:</span>
              <span className="info-value">
                {rowData?.reportPrintBy || "N/A"}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="info-item">
              <span className="info-label">Sample Type:</span>
              <span className="info-value">{rowData?.sampleType || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Age / Sex:</span>
              <span className="info-value">
                {patient?.patient_age
                  ? `${patient?.patient_age.year} Y ${
                      patient?.patient_age.month
                    } M ${patient?.patient_age.days} D / ${
                      patient?.gender?.toLowerCase() === "male" ? "M" : "F"
                    }`
                  : "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Department:</span>
              <span className="info-value">
                {rowData?.lab_department_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Panel:</span>
              <span className="info-value">{rowData?.panel || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Register By:</span>
              <span className="info-value">{rowData?.registerBy || "N/A"}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Collected By:</span>
              <span className="info-value">
                {rowData?.collectedBy || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Lab Received By:</span>
              <span className="info-value">
                {rowData?.labReceivedBy || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Rejected User:</span>
              <span className="info-value">
                {rowData?.rejectedUser || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Sample Reject Reason:</span>
              <span className="info-value">
                {rowData?.sampleRejectReason || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Result Entered By:</span>
              <span className="info-value">
                {rowData?.resultEnteredBy || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved Date:</span>
              <span className="info-value">
                {rowData?.approvedDate || "N/A"}
              </span>
            </div>
            <div className="info-item mt-3">
              <span className="info-label"></span>
              <span className="info-value"></span>
            </div>
            <div className="info-item">
              <span className="info-label">Report Print Date:</span>
              <span className="info-value">
                {rowData?.reportPrintDate || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SampleInformation;
